import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import validateAuth from '../api/auth'
import * as LoadingStates from '../constants/LoadingStates'

const useAuth = (): string => {
  const [searchParams] = useSearchParams({ token: '' })
  const token = searchParams.get('token')
  const iframeBypass = searchParams.get('iframe')
  const [loadingState, setLoadingState] = useState(LoadingStates.LOADING)

  useEffect(() => {
    // For testing environments, allow bypassing iframe
    const inIframe = (): boolean => {
      const allowedDomains = process.env.REACT_APP_IFRAME_DOMAINS?.split(',')

      if (
        process.env.REACT_APP_ALLOW_BYPASS_IFRAME === 'true' &&
        iframeBypass === 'bypass'
      ) {
        return true
      }

      try {
        const { referrer } = document
        const { hostname } = new URL(referrer)
        return (
          window.self !== window.top &&
          (allowedDomains?.includes(hostname) || false)
        )
      } catch (e) {
        return false
      }
    }

    const validateAuthToken = (): void => {
      if (inIframe()) {
        validateAuth(token).then((response) => {
          if (response?.status === 200) {
            setLoadingState(LoadingStates.AUTHENTICATED)
          } else {
            setLoadingState(LoadingStates.DENIED)
          }
        })
      } else {
        setLoadingState(LoadingStates.NOTIFRAME)
      }
    }

    // For testing environments, allow bypassing authentication
    if (
      process.env.REACT_APP_ALLOW_BYPASS_AUTH === 'true' &&
      token === 'bypass'
    ) {
      setLoadingState(LoadingStates.AUTHENTICATED)
    } else {
      validateAuthToken()
    }
  }, [iframeBypass, token])

  return loadingState
}

export default useAuth
